/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SingleSourceData } from './SingleSourceData';
import {
    instanceOfSingleSourceData,
    SingleSourceDataFromJSON,
    SingleSourceDataFromJSONTyped,
    SingleSourceDataToJSON,
} from './SingleSourceData';

/**
 * @type StatisticsBySourceTopChannel1
 * 
 * @export
 */
export type StatisticsBySourceTopChannel1 = SingleSourceData;

export function StatisticsBySourceTopChannel1FromJSON(json: any): StatisticsBySourceTopChannel1 {
    return StatisticsBySourceTopChannel1FromJSONTyped(json, false);
}

export function StatisticsBySourceTopChannel1FromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsBySourceTopChannel1 {
    if (json == null) {
        return json;
    }
    if (instanceOfSingleSourceData(json)) {
        return SingleSourceDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function StatisticsBySourceTopChannel1ToJSON(json: any): any {
    return StatisticsBySourceTopChannel1ToJSONTyped(json, false);
}

export function StatisticsBySourceTopChannel1ToJSONTyped(value?: StatisticsBySourceTopChannel1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfSingleSourceData(value)) {
        return SingleSourceDataToJSON(value as SingleSourceData);
    }

    return {};
}

